@if(data$ | async; as data){
  <cx-generic-link
    [url]="(data.localizedUrl || data.pageLabelOrId) || data.urlLink"
    [target]="getTargetUrl(data)"
    (click)="clickOnPromotion()"
  >
    <div class="dpBanner" [id]="data.uid + '_dpBanner'">
      <div class="dpBannerText">
        <div
          class="dp-headline"
          *ngIf="data.headline"
          [innerHTML]="data.headline"
        ></div>&nbsp;
        <div
          class="dp-content"
          *ngIf="data.content"
          [innerHTML]="data.content"
        ></div>
      </div>
      <cx-media class="media" [container]="data.media" loading="lazy"></cx-media>
    </div>
  </cx-generic-link>
}
